// apiClient.js
// Centralised fetch interceptor. Importing this module (once, from index.js)
// patches window.fetch so that EVERY request to the Project360 API automatically
// carries the `Authorization: Bearer <token>` header issued at login.
//
// This avoids having to edit ~50 individual fetch call sites and guarantees no
// endpoint is accidentally called unauthenticated.

import { getToken, clearSession } from "./session";

const API_HOST = "api-project360-insights.haqdarshak.com";

// Endpoints that must NOT trigger the "session expired -> redirect" behaviour.
// For the login calls a 401 means "wrong credentials", handled inline on the
// login screen; for logout it means the token had already expired, and
// logoutUser() does its own cleanup + redirect either way.
const AUTH_ENDPOINTS = ["microsoft-login", "google-login", "auth/logout"];

const originalFetch = window.fetch.bind(window);

const urlOf = (input) =>
  typeof input === "string" ? input : (input && input.url) || "";

window.fetch = async (input, init = {}) => {
  const url = urlOf(input);
  const isApiCall = url.includes(API_HOST);

  if (isApiCall) {
    const token = getToken();
    const headers = new Headers(
      init.headers ||
        (typeof input !== "string" && input ? input.headers : undefined) ||
        {}
    );
    if (token && !headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    init = { ...init, headers };
  }

  const response = await originalFetch(input, init);

  // Session expired / invalid token -> force re-login (except on the login call).
  const isAuthEndpoint = AUTH_ENDPOINTS.some((e) => url.includes(e));
  if (isApiCall && response.status === 401 && !isAuthEndpoint) {
    clearSession();
    if (window.location.pathname !== "/") {
      window.location.assign("/");
    }
  }

  return response;
};

export default originalFetch;
